var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Alert',{ref:"alert",attrs:{"header":_vm.header,"variant":_vm.variant,"icon":_vm.icon,"message":_vm.msg,"dismissible":true},on:{"dismissed":function($event){return _vm.$emit("dismissed")}}})}
var staticRenderFns = []

export { render, staticRenderFns }